import $ from 'jquery'

//'use strict';

		var wc_checkout_coupons = {
			init: function() {
				$(document.body).on('click', 'a.showcoupon', this.show_coupon_form);
				$(document.body).on('click', '.eaplus-remove-coupon', this.remove_coupon);
				$(document.body).on('click', 'button[name="eaplus_apply_coupon"]', this.submit);
			},
			show_coupon_form: function () {

				$('.checkout_coupon').slideToggle(400, function() {
					$('.checkout_coupon').find(':input:eq(0)').trigger('focus');
				});
				return false;
			},
			submit: function () {

				// wc_checkout_params is required to continue, ensure the object exists
				if (typeof wc_checkout_params === 'undefined') {
					return false;
				}

				var $form = $('form[name="checkout"]');
				if ($form.is('.processing')) {
					return false;
				}

				$form.addClass('processing').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});

				var data = {
					security: wc_checkout_params.apply_coupon_nonce,
					coupon_code: $form.find('input[name="coupon_code"]').val()
				};

				$.ajax({
					type: 'POST',
					url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
					data: data,
					success: function(code) {
						$('.woocommerce-error, .woocommerce-message').remove();
						$form.removeClass('processing').unblock();

						if (code) {
							// $form.before(code);
							// $form.slideUp();
							$('div.coupon-form').after(code);

							$(document.body).trigger('applied_coupon_in_checkout', [data.coupon_code]);
							$(document.body).trigger('update_checkout', {
								update_shipping_method: false
							});
						}
					},
					dataType: 'html'
				});

				return false;
			},
			remove_coupon: function (e) {

				// wc_checkout_params is required to continue, ensure the object exists
				if (typeof wc_checkout_params === 'undefined') {
					return false;
				}

				e.preventDefault();
				var container = $(this).parents('.woocommerce-checkout-review-order'),
					coupon = $(this).data('coupon');

				container.addClass('processing').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});

				var data = {
					security: wc_checkout_params.remove_coupon_nonce,
					coupon: coupon
				};

				$.ajax({
					type: 'POST',
					url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
					data: data,
					success: function(code) {
						$('.woocommerce-error, .woocommerce-message').remove();
						container.removeClass('processing').unblock();

						if (code) {
							//$('form.woocommerce-checkout').before(code);

							$('div.cart-discount').after(code);

							$(document.body).trigger('removed_coupon_in_checkout', [data.coupon]);
							$(document.body).trigger('update_checkout', {
								update_shipping_method: false
							});

							// Remove coupon code from coupon field
							$('form.checkout_coupon').find('input[name="coupon_code"]').val('');
						}
					},
					error: function(jqXHR) {
						if (wc_checkout_params.debug_mode) {
							/* jshint devel: true */
							console.log(jqXHR.responseText);
						}
					},
					dataType: 'html'
				});
			}
		};

		wc_checkout_coupons.init();

// Checkout validation
//Validate email
      $('body').on('blur change', '#billing_email', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^.+@.{2,}\./);
        var pattern = new RegExp(/^(?=.{1,50}$).+@.{2,}\./);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate first name
      $('body').on('blur change', '#billing_first_name', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
        var pattern = new RegExp(/^(?=.{1,14}$)[a-zA-Z \-\']*$/i);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate Middle Initial
      $('body').on('blur change', '#billing_middle_initial', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
        var pattern = new RegExp(/^(?=.{0,1}$)[a-zA-Z]*$/i);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate last name
      $('body').on('blur change', '#billing_last_name', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
        var pattern = new RegExp(/^(?=.{1,15}$)[a-zA-Z \-\']*$/i);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate billing address 1
      $('body').on('blur change', '#billing_address_1', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[^?]*$/);
        var pattern = new RegExp(/^(?=.{5,30}$)[^?]*$/);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate billing address 2
      $('body').on('blur change', '#billing_address_1', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[^?]*$/);
        var pattern = new RegExp(/^(?=.{0,30}$)[^?]*$/);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate city
      $('body').on('blur change', '#billing_city', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        //var pattern = new RegExp(/^[a-zA-Z \-\']*$/i);
        var pattern = new RegExp(/^(?=.{2,19}$)[a-zA-Z \-\']*$/i);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      //Validate state
      $('body').on('blur change', '#billing_state', function() {
        const wrapper = $(this).closest('.form-row');
        // you do not have to removeClass() because Woo do it in checkout.js
        if ($(this).val() == 'NY') {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      // Validate Zip code
      $('body').on('blur change', '#billing_postcode', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        var pattern = new RegExp(/^\d{5}(-\d{4})?$/);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
      // Validate phone
      $('body').on('blur change', '#billing_phone', function() {
        const wrapper = $(this).closest('.form-row');
        // Regex pattern
        var pattern = new RegExp(/^[0-9\-\.]{0,12}$/);
        // you do not have to removeClass() because Woo do it in checkout.js
        if (!pattern.test($(this).val())) {
          wrapper.removeClass('woocommerce-validated').addClass('woocommerce-invalid'); // error
        } else {
          wrapper.addClass('woocommerce-validated'); // success
        }
      });
